import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, getCurrentInstance, onMounted } from 'vue'
import CommonState from '@/services/locale-state'

export default /*#__PURE__*/_defineComponent({
  __name: 'Language',
  setup(__props) {

const defaultLang = ref<string>(CommonState.getLocale() || 'en')
const onChangeLocale = (lang) => {
  if (lang) {
    CommonState.setLocale(lang)
  }
}

onMounted(() => {
  const vm = getCurrentInstance()
  if (vm?.ctx?.$i18n?.locale) {
    defaultLang.value = vm.ctx.$i18n.locale
  }
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return ('vn' == _ctx.$root.$i18n.locale)
    ? (_openBlock(), _createBlock(_component_SvgIcon, {
        key: 0,
        class: "_pointer-on-hover mr-1 inline-flex",
        icon: "vn",
        height: "24",
        "aria-hidden": "true",
        onClick: _cache[0] || (_cache[0] = 
      (e) => {
        _ctx.$root.$i18n.locale = 'th'
        onChangeLocale(_ctx.$root.$i18n.locale)
      }
    )
      }))
    : ('th' == _ctx.$root.$i18n.locale)
      ? (_openBlock(), _createBlock(_component_SvgIcon, {
          key: 1,
          class: "_pointer-on-hover mr-1 inline-flex",
          icon: "th",
          height: "24",
          "aria-hidden": "true",
          onClick: _cache[1] || (_cache[1] = 
      (e) => {
        _ctx.$root.$i18n.locale = 'en'
        onChangeLocale(_ctx.$root.$i18n.locale)
      }
    )
        }))
      : (_openBlock(), _createBlock(_component_SvgIcon, {
          key: 2,
          class: "_pointer-on-hover mr-1 inline-flex",
          icon: "uk",
          height: "24",
          "aria-hidden": "true",
          onClick: _cache[2] || (_cache[2] = 
      (e) => {
        _ctx.$root.$i18n.locale = 'vn'
        onChangeLocale(_ctx.$root.$i18n.locale)
      }
    )
        }))
}
}

})